module.exports = __webpack_public_path__ + "static/averta-extrabold-webfont-eff5ed6b936e610b0a2c6a6ab03b88b1.woff2";